import { render } from "./EditorSelection.vue?vue&type=template&id=40b90966&scoped=true"
import script from "./EditorSelection.vue?vue&type=script&lang=js"
export * from "./EditorSelection.vue?vue&type=script&lang=js"

import "./EditorSelection.vue?vue&type=style&index=0&id=40b90966&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b90966"]])

export default __exports__